const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [{ useCustomerStore }, { useFeaturesStore }] = await Promise.all([
      import('@/stores/customer'),
      import('@/stores/features')
    ])
    // Getters, not resolved instances: a cached store instance belongs to
    // whichever pinia was active on first use, which on the server is another
    // request's app (VIP-12037).
    cache = {
      get customer() {
        return useCustomerStore()
      },
      get features() {
        return useFeaturesStore()
      }
    }
    return cache
  }
})()

const _loginUrl = (_t) => {
  // The target route carries the same query as the address bar, and unlike
  // `window.location` it also exists during a server render (VIP-12037)
  const redirectParam = _t?.query?.redirect ?? null

  return redirectParam
    ? `/auth/v2/login?redirect_uri=${encodeURIComponent(redirectParam)}`
    : `/auth/v2/login?redirect_uri=${_t?.fullPath || '/'}`
}

const customerGuardV2 = async (_t, _f, next) => {
  const { customer } = await _getModules()

  await customer.waitUntilPending()

  if (!customer.customerSoftLoggedIn) {
    next(_loginUrl(_t))
    return
  }

  next()
}

const adminGuard = async (_t, _f, next) => {
  const { customer } = await _getModules()

  await customer.waitUntilPending()

  // Nobody logged in is not the same as forbidden: send them through login and
  // back, and keep the error page for a signed-in non-admin.
  if (!customer.customerSoftLoggedIn) {
    next(_loginUrl(_t))
    return
  }

  if (customer.customerIsAdmin) {
    next()
    return
  }

  return next({ name: 'error' })
}

export { adminGuard, customerGuardV2 }
